const getAllCountries = (locale = 'en') => {
  const codes = [
    'AF','AX','AL','DZ','AS','AD','AO','AI','AQ','AG','AR','AM','AW','AU','AT','AZ',
    'BS','BH','BD','BB','BY','BE','BZ','BJ','BM','BT','BO','BQ','BA','BW','BV','BR',
    'IO','BN','BG','BF','BI','KH','CM','CA','CV','KY','CF','TD','CL','CN','CX','CC',
    'CO','KM','CG','CD','CK','CR','CI','HR','CU','CW','CY','CZ','DK','DJ','DM','DO',
    'EC','EG','SV','GQ','ER','EE','SZ','ET','FK','FO','FJ','FI','FR','GF','PF','TF',
    'GA','GM','GE','DE','GH','GI','GR','GL','GD','GP','GU','GT','GG','GN','GW','GY',
    'HT','HM','VA','HN','HK','HU','IS','IN','ID','IR','IQ','IE','IM','IL','IT','JM',
    'JP','JE','JO','KZ','KE','KI','KP','KR','KW','KG','LA','LV','LB','LS','LR','LY',
    'LI','LT','LU','MO','MG','MW','MY','MV','ML','MT','MH','MQ','MR','MU','YT','MX',
    'FM','MD','MC','MN','ME','MS','MA','MZ','MM','NA','NR','NP','NL','NC','NZ','NI',
    'NE','NG','NU','NF','MK','MP','NO','OM','PK','PW','PS','PA','PG','PY','PE','PH',
    'PN','PL','PT','PR','QA','RE','RO','RU','RW','BL','SH','KN','LC','MF','PM','VC',
    'WS','SM','ST','SA','SN','RS','SC','SL','SG','SX','SK','SI','SB','SO','ZA','GS',
    'SS','ES','LK','SD','SR','SJ','SE','CH','SY','TW','TJ','TZ','TH','TL','TG','TK',
    'TO','TT','TN','TR','TM','TC','TV','UG','UA','AE','GB','US','UM','UY','UZ','VU',
    'VE','VN','VG','VI','WF','EH','YE','ZM','ZW'
  ] // ISO

  const names = new Intl.DisplayNames([locale], { type: 'region' })

  return codes
    .filter(c => /^[A-Z]{2}$/.test(c))
    .sort()
    .map(code => ({
      code,
      name: names.of(code)
    }))
}

// Build lookup maps at module load
const _countries = getAllCountries('en')
const codeToNameMap = new Map(
  _countries.map(({ code, name }) => [code, name])
)
const nameToCodeMap = new Map(
  _countries.map(({ code, name }) => [name.toLowerCase(), code])
)

const getCountryName = (countryCode) => {
  if (!countryCode) return ''
  if (['UN', 'unknown'].includes(countryCode)) return 'Unknown'
  const code = countryCode.toUpperCase()
  return codeToNameMap.get(code) || countryCode
}

const getCountryCode = (countryName) => {
  if (!countryName) return ''
  const key = countryName.trim().toLowerCase()
  return nameToCodeMap.get(key) || countryName
}

const getCountrySquareFlag = (countryCode) => {
  if (['UN', 'unknown'].includes(countryCode)) return null
  const code = countryCode.toLowerCase()
  return `https://cdn.jsdelivr.net/npm/flag-icons@7.5.0/flags/1x1/${code}.svg`
}

export { 
  getCountryName, 
  getCountryCode, 
  getAllCountries,
  getCountrySquareFlag
}